"use client";

import { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";
import axios from "axios";

export default function DraftModeEnforcer() {
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    const checkDraftMode = async () => {
      const isTinaAuth = window.self !== window.top;
      // typeof window !== "undefined" && localStorage.getItem("tinacms-auth") !== null;

      if (isTinaAuth) {
        const {
          data: { isEnabled: isDraftMode },
        } = await axios.get("/api/draft-mode/check");

        if (!isDraftMode) {
          const tinacmsAuth = JSON.parse(localStorage.getItem("tinacms-auth") || "{}");
          const token = tinacmsAuth.access_token || "";

          router.push(
            `/api/draft-mode/enter?slug=${encodeURIComponent(pathname)}&token=${encodeURIComponent(
              token
            )}`
          );
        }
      } else {
        const {
          data: { isEnabled: isDraftMode },
        } = await axios.get("/api/draft-mode/check");

        if (isDraftMode) {
          router.push(`/api/draft-mode/exit?slug=${encodeURIComponent(pathname)}`);
        }
      }
    };

    checkDraftMode();
  }, [pathname, router]);

  return null;
}
